<template>
  <AutocompleteField
    :value="model"
    :items="items"
    :loading="loading"
    :placeholder="context.attributes.placeholder || 'Type an ICD code or term…'"
    @input="model = $event"
    @search="search"
    @items-clear="items = []"
    @select="onSelect"
  />
</template>

<script>
// Custom vue-formulate type "icd": morbidity / comorbidity autocomplete backed
// by the free public NLM ICD-10-CM API (no auth, CORS-enabled). Stores the value
// as "<code> - <name>" to match the original app's format.
import axios from 'axios'

const ICD_ENDPOINT =
  process.env.VUE_APP_ICD_SEARCH_ENDPOINT ||
  'https://clinicaltables.nlm.nih.gov/api/icd10cm/v3/search'

export default {
  name: 'FormulateIcdAutocomplete',
  props: { context: { type: Object, required: true } },
  data() {
    return { items: [], loading: false }
  },
  computed: {
    model: {
      get() {
        return this.context.model || ''
      },
      set(v) {
        this.context.model = v
      },
    },
  },
  methods: {
    async search(q) {
      this.loading = true
      try {
        // NLM returns [total, [codes], null, [[code, name], ...]]
        const { data } = await axios.get(ICD_ENDPOINT, {
          params: { sf: 'code,name', terms: q, maxList: 20 },
        })
        const rows = (data && data[3]) || []
        this.items = rows.map(([code, name]) => ({
          label: `${code} - ${name}`,
          value: `${code} - ${name}`,
        }))
      } catch (e) {
        this.items = []
      } finally {
        this.loading = false
      }
    },
    onSelect(item) {
      this.model = item.value
      this.items = []
    },
  },
}
</script>
